import React from 'react'
import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { productsActions } from '../../../store/products-slice';
import { stepsActions } from '../../../store/steps-slice';
import { sidebarActions } from '../../../store/sidebar-slice';

const CreateCampaignBtn = (props) => {
    const dispatch=useDispatch();
    function handleAddNewProduct(){
        dispatch(stepsActions.handleRedirection(false));
        dispatch(productsActions.setEditProductDetails(null));
    }
    function handleRoute(){
        dispatch(sidebarActions.setRoute("/create-campaign"));
    }
    return (
        <div className="createCampaignBtn">
         
            <Link style={{textDecoration: "none"}} to={props.url}  onClick={props.url==="/create-campaign" ? handleRoute : handleAddNewProduct}>
             <button {...props} className='create-campaign-link'>
                <img className='c-btn-add-icon' src="/assets/icons/add.svg" alt="add-icon" />
                <p className="c-btn-text">{props.text}</p>
                </button>
            </Link>
           
        </div>
    )
}

export default CreateCampaignBtn